import Hero3D from "@/components/hero-3d/Hero3D"
import Typography from "@/components/typography/Typography"
import BookDemoButton from "@/components/website/book-demo-button/BookDemoButton"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import { Col, Row } from "antd"
import { FC } from "react"
import LogoSlider from "../../../components/logo-slider/LogoSlider"
import "./HeroSection.less"
import bgImage from "./assets/bg-img-resized.webp"
import heroImg from "./assets/main-img-resized.webp"

const { Paragraph, Title } = Typography

const titleParts = [
  { text: "Process ", variant: "w700" },
  { text: "more ", variant: "orange-bold" },
  { text: "wayleave applications in ", variant: "w700" },
  { text: "less time.", variant: "orange-bold" },
]

const heroVisualLabel =
  "Isometric smart city: buildings, roads, utilities and engineering infrastructure connected around the Easetech logo"

const heroSubtitleParts = [
  { text: "Endless emails, manual admin, and chasing stakeholders are ", variant: "subtitle-secondary" },
  { text: "holding your team back.", variant: "subtitle-bold" },

  { text: " Take control with one system ", variant: "subtitle-secondary" },
  { text: "built to handle more applications.", variant: "subtitle-bold" },
]

const HeroSection: FC = () => {
  const { xxl, xl, lg, md, sm, xs } = useBreakpoint()

  return (
    <div className={"new-hero-section-wrapper"}>
      <div className={"bg-image-wrapper"}>
        <img src={bgImage} alt={""} />
      </div>

      <div className={"container"}>
        <Row justify={"center"} className={"new-hero-section-row"}>
          <Col
            span={10}
            xxl={10}
            xl={10}
            lg={10}
            md={20}
            sm={20}
            xs={23}
            className={"new-hero-section-text"}
            style={{ paddingBottom: 24 }}
          >
            <Row align={"middle"} justify={!(xxl || xl || lg) ? "center" : "start"} style={{ height: "100%" }}>
              <Col xxl={24} xl={24} lg={24} md={20} sm={20} xs={23}>
                <Title
                  level={1}
                  sizeAs={xxl || xl || lg || md || sm ? 2 : 3}
                  color={"white"}
                  centered={!(xxl || xl || lg)}
                  style={{ paddingBottom: !(xxl || xl || lg) ? 0 : 24, paddingTop: !(xxl || xl) ? 24 : 0 }}
                >
                  {titleParts.map((part, i) => (
                    <span key={i} className={`title ${part.variant}`}>
                      {part.text}
                    </span>
                  ))}
                </Title>

                <Col span={24}>
                  <Row>
                    <Col xxl={16} xl={16} lg={24} md={24} sm={24} xs={24}>
                      <Paragraph
                        style={{ paddingTop: 24, paddingBottom: xxl || xl || lg ? 80 : 32 }}
                        size={"lg"}
                        centered={!(xxl || xl || lg)}
                        color={"white"}
                        lh={"lh-lg"}
                      >
                        {heroSubtitleParts.map((part, i) => (
                          <span key={i} className={part.variant}>
                            {part.text}
                          </span>
                        ))}
                      </Paragraph>
                    </Col>
                  </Row>
                </Col>

                <Row
                  align={"middle"}
                  style={{ height: "100%", paddingBottom: !(xxl || xl || lg) ? 12 : 0 }}
                  justify={!(xxl || xl || lg) ? "center" : "start"}
                >
                  <BookDemoButton type={"orange"} />
                </Row>
              </Col>
            </Row>
          </Col>

          <Col xxl={12} xl={14} lg={13} md={16} sm={20} xs={23} style={{ paddingLeft: xxl || xl || lg ? 24 : "unset" }}>
            <div className={"hero-img-box"}>
              <div className={"hero-img-wrapper"}>
                <Hero3D
                  fallbackSrc={heroImg}
                  fallbackAlt={""}
                  ariaLabel={heroVisualLabel}
                  modelUrl={"/models/smart_city_engineering-v6.min.glb"}
                />
              </div>
            </div>
          </Col>
        </Row>

        <div className={"new-hero-section-trusted"}>
          <Row justify={"center"}>
            <Paragraph color={"gray"} size={"lg"}>
              {"Trusted by:"}
            </Paragraph>
          </Row>

          <LogoSlider />
        </div>
      </div>
    </div>
  )
}

export default HeroSection
